import { Box, IconButton, Stack, Tooltip, Typography } from '@mui/material';
import React, { useCallback, useState } from 'react'
import { onGetFullImagePath } from '../../../utils/general';
import Image from '../../images/Image';
import { blueGrey } from '@mui/material/colors';
import Iconify from '../../iconify';
import styled from '@emotion/styled';
import { saveAs } from 'file-saver';
import ConfirmDialog from '../../confirm-dialog';
import UploadDocument from '../../upload/UploadDocument';
import ContainedButton from '../../actions/ContainedButton';
import UploadSquare from '../../upload/UploadSquare';
import Upload from '../../upload/Upload';
import useOrder from '../../../hooks/api/useOrder';

const OrderFile = ({
    id,
    title,
    src,
    order_id,
    user_id
}) => {

    const orderManager = useOrder()

    const [open, setOpen] = useState(false)
    const [newFile, setNewFile] = useState()

    const _file = onGetFullImagePath(src)

    const onClose = useCallback(() => {
        setNewFile(null)
        setOpen(false)
    }, [])

    const onDrop = useCallback((acceptedFiles) => {
        if(acceptedFiles.length){
            const _file = acceptedFiles[0]
            const newFile = Object.assign(_file, {
                preview: URL.createObjectURL(_file),
            });
            //console.log(newFile)
            if(_file){
                setNewFile(newFile)
            }
            //setFile(_data[0])
        }
    }, [])

    const onSubmit = useCallback(async() => {
        try {
            const response = await orderManager.actions.onUpdateFile(user_id, order_id, id, newFile)
        } catch (error) {
            console.log(error)
            
        }
    }, [id, newFile, order_id, user_id])

    const onDownload = useCallback(async() => {
        saveAs(_file, id)
    }, [_file, id])

    const onUpload = useCallback(() => {
        setOpen(true)
    }, [_file])


    return ( 
        <>
        
            <Stack>
                <div>
                    <Box sx={{
                        px:1, py:1,
                        border:`2px dashed ${blueGrey[300]}`,
                        borderRadius:1,
                        position:'relative'
                    }}>
                        {_file && <Image src={_file} ratio="16/9" />}
                        {!_file && (
                            <Box sx={{pt:"56.25%", position:"relative"}}>
                                <Box sx={{  
                                    position:'absolute', top:'50%', left:'50%', transform:"translate(-50%, -50%)"
                                }}>
                                    <Iconify icon="solar:camera-bold" width={48} color={blueGrey[300]} />
                                </Box>
                            </Box>
                        )}
                        <Box sx={{
                            position:'absolute',
                            bottom:6, right:6
                        }}>
                            <Stack direction='row' spacing={1}>
                                {/*<Tooltip title="Subir">
                                    <StyledIconButton color='primary' onClick={onUpload}>
                                        <Iconify icon="ic:round-upload" />
                                    </StyledIconButton>
                    </Tooltip>*/}
                                <Tooltip title="Descargar">
                                    <StyledIconButton color='primary' onClick={onDownload}>
                                        <Iconify icon="ic:round-download" />
                                    </StyledIconButton>
                                </Tooltip>
                            </Stack>
                        </Box>
                        
                    </Box>
                </div>
                <Typography variant='body2' color='text.secondary'>{title}</Typography>
            </Stack>
            <ConfirmDialog
                open={open}
                onClose={onClose}
                title="Subir documento"
                content={(
                    <Upload
                        accept={{'image/*': []}}
                        file={newFile}
                        onDrop={onDrop}
                     />
                )}
                action={
                <ContainedButton size='small' onClick={onSubmit}>
                    Subir
                </ContainedButton>
                }
            />
        </>
     );
}

export const StyledIconButton = styled(IconButton)(({ theme }) => ({
    background: "white",
    border:`1px solid ${theme.palette.primary.main}`,
    padding:4,
    '&:hover':{
        background:'white'
    }

}));
  
 
export default OrderFile;